<template>
    <div>
        <h3 class="menus-title">{{ strings.menus }} </h3>
        <multiselect :max="maxMenu" v-model="valueMenu" :placeholder="strings.searchForMenus" label="name" track-by="id" :options="operaMenus" :hideSelected="true" :multiple="true" selectLabel=" "></multiselect>
        <table-component
                style="margin-bottom: 0px !important;"
                v-show="valueMenu.length > 0"
                :show-filter="false"
                :data="valueMenu"
                sort-by="name"
                sort-order="asc"
                filter-no-results="There is no item in the list"
        >
            <table-column show="name" label="Menu name" cell-class="tableCellClass" ></table-column>
            <table-column label="Service time" cell-class="tableCellClass" header-class="serviceTimeInput">
                <template scope="row">
                    <select :value="row.service_time" :data-id="row.id" class="form__input service_time_from" @change="changeMenuServiceTime($event)">
                        <option v-show="isServiceTimeBetween(item.value)" v-for="item in serviceTimeList" :key="item.id" :value="item.value"> {{ item.text }} </option>
                    </select>
                </template>
            </table-column>
            <table-column label="Delegates" header-class="amountInput">
                <template scope="row">
                    <input type="number" :data-id="row.id" class="form__input" :value="row.amount" @change="changeMenuTotal($event)" />
                </template>
            </table-column>
            <table-column show="priceWithCC" label="Price" cell-class="tableCellClass"></table-column>
            <template slot="tfoot" scope="{ rows }" >
                <tr v-show="valueMenu.length > 0">
                    <th>{{ strings.total }}</th>
                    <th></th>
                    <th></th>
                    <th>{{ rows.reduce((sum, value) => { return sum + (value.data.price * value.data.amount); }, 0).toFixed(2) }} {{ currency_symbol }}</th>
                </tr>
            </template>
        </table-component>

        <h3 v-if="operaMiscItems.length > 0" class="misc-title" style="margin-top: 20px !important;">{{ strings.miscellaneousItems }}</h3>
        <multiselect v-model="valueMisc" :placeholder="strings.searchForMiscItems" label="name" track-by="id" :options="operaMiscItems" :multiple="true" :hideSelected="true" selectLabel=" "></multiselect>

        <table-component
                v-show="valueMisc.length > 0"
                :show-filter="false"
                :data="valueMisc"

                sort-by="name"
                sort-order="asc"
                filter-no-results="There is no item in the list"
        >
            <table-column show="name" label="Item name" cell-class="tableCellClass"></table-column>
            <table-column label="Service time" cell-class="tableCellClass" header-class="serviceTimeInput">
                <template scope="row">
                    <select :value="row.service_time" :data-id="row.id" class="form__input service_time_from" @change="changeMiscServiceTime($event)">
                        <option v-show="isServiceTimeBetween(item.value)" v-for="item in serviceTimeList" :key="item.id" :value="item.value"> {{ item.text }} </option> 
                    </select>
                </template>
            </table-column>
            <table-column label="Amount" header-class="amountInput">
                <template scope="row">
                    <select class="form__input" :data-id="row.id" :value="row.amount" @change="changeTotal($event)" v-if="row.availability">
                        <option 
                            v-for="n in row.availability[convertDate(startD)]" 
                            :value="n" 
                            :selected="n == row.amount"
                            :key="n">{{ n }}</option>
                    </select>
                    <input type="number" :data-id="row.id" class="form__input" :value="row.amount" @change="changeTotal($event)" v-else/>
                </template>
            </table-column>
            <table-column show="priceWithCC" label="Price" cell-class="tableCellClass" header-class="amountInput"></table-column>
            <template slot="tfoot" scope="{ rows }" >
                <tr v-show="valueMisc.length > 0">
                    <th>{{ strings.total }}</th>
                    <th></th>
                    <th></th>
                    <th>{{ rows.reduce((sum, value) => { return sum + (value.data.price * value.data.amount  * temp(mt_length, value.data.isHourlyRate)); }, 0).toFixed(2) }} {{ currency_symbol }}</th>
                </tr>
            </template>
        </table-component>
    </div>
</template>

<script>
    import Multiselect from 'vue-multiselect'
    import Vue from 'vue'
    import moment from 'moment';

    export default {
        name: "AddonsList",
        data () {
            return {
                value : [],
                valueMisc : [],
                valueMenu: [],
                localMiscItems: this.$store.state.operaMiscItems,
                maxMenu : window.location.hostname == 'meetings.leonardohotels.co.uk' ? 1 : 7777, // #hack for jurysinns,
                serviceTimeList: [
                    { id : 1, text: "--:--", value: "--:--" }, 
                    { id : 2, text: "00:00", value: "00:00" }, 
                    { id : 3, text: "00:30", value: "00:30" }, 
                    { id : 4, text: "01:00", value: "01:00" }, 
                    { id : 5, text: "01:30", value: "01:30" }, 
                    { id : 6, text: "02:00", value: "02:00" }, 
                    { id : 7, text: "02:30", value: "02:30" }, 
                    { id : 8, text: "03:00", value: "03:00" }, 
                    { id : 9, text: "03:30", value: "03:30" }, 
                    { id : 10, text: "04:00", value: "04:00" }, 
                    { id : 11, text: "04:30", value: "04:30" }, 
                    { id : 12, text: "05:00", value: "05:00" }, 
                    { id : 13, text: "05:30", value: "05:30" }, 
                    { id : 14, text: "06:00", value: "06:00" }, 
                    { id : 15, text: "06:30", value: "06:30" }, 
                    { id : 16, text: "07:00", value: "07:00" }, 
                    { id : 17, text: "07:30", value: "07:30" }, 
                    { id : 18, text: "08:00", value: "08:00" }, 
                    { id : 19, text: "08:30", value: "08:30" }, 
                    { id : 20, text: "09:00", value: "09:00" }, 
                    { id : 21, text: "09:30", value: "09:30" }, 
                    { id : 22, text: "10:00", value: "10:00" }, 
                    { id : 23, text: "10:30", value: "10:30" }, 
                    { id : 24, text: "11:00", value: "11:00" }, 
                    { id : 25, text: "11:30", value: "11:30" }, 
                    { id : 26, text: "12:00", value: "12:00" }, 
                    { id : 27, text: "12:30", value: "12:30" }, 
                    { id : 28, text: "13:00", value: "13:00" }, 
                    { id : 29, text: "13:30", value: "13:30" }, 
                    { id : 30, text: "14:00", value: "14:00" }, 
                    { id : 31, text: "14:30", value: "14:30" }, 
                    { id : 32, text: "15:00", value: "15:00" }, 
                    { id : 33, text: "15:30", value: "15:30" }, 
                    { id : 34, text: "16:00", value: "16:00" }, 
                    { id : 35, text: "16:30", value: "16:30" }, 
                    { id : 36, text: "17:00", value: "17:00" }, 
                    { id : 37, text: "17:30", value: "17:30" }, 
                    { id : 38, text: "18:00", value: "18:00" }, 
                    { id : 39, text: "18:30", value: "18:30" }, 
                    { id : 40, text: "19:00", value: "19:00" }, 
                    { id : 41, text: "19:30", value: "19:30" }, 
                    { id : 42, text: "20:00", value: "20:00" }, 
                    { id : 43, text: "21:00", value: "21:00" }, 
                    { id : 44, text: "20:30", value: "20:30" }, 
                    { id : 45, text: "21:30", value: "21:30" }, 
                    { id : 46, text: "22:00", value: "22:00" }, 
                    { id : 47, text: "22:30", value: "22:30" }, 
                    { id : 48, text: "23:00", value: "23:00" }, 
                    { id : 49, text: "23:30", value: "23:30" },
                ]
            }
        },
        props: ['item_index', 'currency_symbol' , 'mt_length', 'startD', 'endD'],
        components: {
            Multiselect
        },
        computed: {
            strings () {
                return this.$store.state.strings;
            },
            checkoutItems () {
                return this.$store.state.checkOutItemsOpera;
            },
            operaMenus() {
                return this.$store.state.operaMenus;
            },
            operaMenuItems() {
                return this.$store.state.operaMenuItems;
            },
            operaMiscItems() {
                return this.$store.state.operaMiscItems;
            },
        },
        watch: {
            valueMenu: function(value) {
                this.setItemAdditionalItems(value, "services");
            },
            valueMisc: function(value) {
                this.setItemAdditionalItems(value, "addons");
            }
        },
        methods: {
            convertDate(date){
                return moment(date, 'DD-MM-YYYY HH:mm').format('YYYY-MM-DD');
            },
            isServiceTimeBetween(serviceTime){
                let format = 'DD-MM-YYYY HH:mm';
                let date = moment(this.startD, format).format('DD-MM-YYYY');
                let beforeTime = moment(this.startD, format);
                let afterTime = moment(this.endD, format);
                let time = moment(date + ' ' + serviceTime, format);
                if (time.isBetween(beforeTime, afterTime) || time.isSame(beforeTime) || time.isSame(afterTime)) {
                    return true;
                } else {
                    return false;
                }
            },
            temp(meeting_length, isHourlyRate){
                if(isHourlyRate){
                    return parseInt(meeting_length);
                } else {
                    return 1;
                }
            },
            setItemAdditionalItems: function(value, name) {
                let total = 0;
                let self = this;
                let currentItem = this.checkoutItems[this.item_index];
                value.forEach(element => {
                    let menuAddon = {"id": element.id, "amount": element.amount, "price": element.price, "service_time": element.service_time, "name": element.name};
                    // Check and remove the old one before pushing a new one.
                    currentItem[name] = currentItem[name].filter(function(el){
                        return el.id != element.id;
                    });
                    currentItem[name].push(menuAddon);
                    total = total + (element.price *  element.amount * 100 * self.temp(self.mt_length, element.isHourlyRate));

                });
                if(value.length == 0){
                     currentItem[name] = [];
                }
                currentItem["total_" + name] = total;
                currentItem["total_price"] = currentItem["room"]["total_price"] + parseInt(currentItem["total_services"]) + parseInt(currentItem["total_addons"]);
                let addonsTotal = this.$store.state.addonsTotal + total;
                this.checkoutItems[this.item_index] = currentItem;
                this.$store.commit('setCheckOutItemsOpera', this.checkoutItems);
                this.$store.commit('setAddonsTotal', addonsTotal);
            },
            changeMiscServiceTime(event){
                let inputChangeID = event.target.attributes['data-id'].value;

                this.valueMisc.forEach( (element, index) => {
                    if( parseInt(element.id) == parseInt(inputChangeID) ){
                        element.service_time = event.target.value;
                        Vue.set(this.valueMisc, index, element);
                    }
                });

                this.operaMiscItems.forEach(el => {
                    if( parseInt(el.id) == parseInt(inputChangeID) ){
                        el.service_time = event.target.value;
                        this.setItemAdditionalItems(this.valueMisc, "addons");
                    }
                });
                this.$store.commit('setOperaMiscItems', this.operaMiscItems);
            },
            changeMenuServiceTime(event){
                let inputChangeID = event.target.attributes['data-id'].value;

                this.valueMenu.forEach( (element , index) => {
                    if( parseInt(element.id) == parseInt(inputChangeID) ){
                        element.service_time = event.target.value;
                        Vue.set(this.valueMenu, index, element);
                    }
                });

                this.operaMenus.forEach(el => {
                    if( parseInt(el.id) == parseInt(inputChangeID) ){
                        el.service_time = event.target.value;
                        this.setItemAdditionalItems(this.valueMenu, "services");
                    }
                });
                this.$store.commit('setOperaMenus', this.operaMenus);
            },
            changeTotal(event) {
                let inputChangeID = event.target.attributes['data-id'].value;

                this.valueMisc.forEach((element, index) => {
                    if( parseInt(element.id) == parseInt(inputChangeID) ){
                        element.amount = parseInt(event.target.value);
                        Vue.set(this.valueMisc, index, element);
                    }
                });

                this.operaMiscItems.forEach(el => {
                    if( parseInt(el.id) == parseInt(inputChangeID) ){
                        el.amount = parseInt(event.target.value);
                        this.setItemAdditionalItems(this.valueMisc, "addons");
                    }
                });

                this.$store.commit('setOperaMiscItems', this.operaMiscItems);
            },
            changeMenuTotal(event){
                let inputChangeID = event.target.attributes['data-id'].value;
                this.valueMenu.forEach( (element, index) => {
                    if( parseInt(element.id) == parseInt(inputChangeID) ){
                        element.amount = parseInt(event.target.value);
                        Vue.set(this.valueMenu, index, element);
                    }
                });

                this.operaMenus.forEach(el => {
                    if( parseInt(el.id) == parseInt(inputChangeID) ){
                        el.amount = parseInt(event.target.value);
                        this.setItemAdditionalItems(this.valueMenu, "services");
                    }
                });
                this.$store.commit('setOperaMenus', this.operaMenus);
            },
        }

    }
</script>

<style scoped>
    .accordion-block .menus-title, .accordion-block .misc-title{
        font-size: 18px;
    }
    .accordion-block .menus-title{
        margin-top:15px;
    }
    .accordion-block .checkout-title{
        font-size: 20px;
        margin-top:20px;
    }
</style>